import _ from "lodash";
import store from "store";

export default {
  setShows(state, shows) {
    state.shows = shows;
  },
  setShowDetails(state, details) {
    state.currentShowDetails = details;
  },
  setCurrentId(state, id) {
    state.currentShowId = id;
  },
  setUser(state, user) {
    state.user = user;
    state.userLoaded = true;
  },
  setEditingActiveShowId(state, id) {
    state.editingActiveShowId = id;
  },
  addShow(state, show) {
    state.shows.push(show);
    store.set("shows", state.shows);
  },
  addAudioToShow(state, audioObj) {
    var show = _.find(state.shows, { id: audioObj.showId });
    delete audioObj["showId"];
    show.audio = audioObj;
    store.set("shows", state.shows);
  },
  saveSlideArrayToShow(state, showObj) {
    state.currentShowDetails.data.slideArray = showObj.slideArray;
  }
};
